import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import FormsService from "../../../services/FormsService";
import FormWrarper from "../../Forms/FormWrarper";
import BlocPayLogo from "../../../admin/components/crud/entities/BlocPayLogo";
import UELoaderAnim from "../../../admin/components/UELoaderAnim";
import ProgressBar from "../../utilities/ProgressBar";
import Styles from "./StoreFormProcess.css";

const StoreFormProcess = (props) => {
   const [selectedForm, setSelectedForm] = useState();
   const [forms, setForms] = useState(props.forms);
   const [processRun, setProcessRun] = useState(null);
   const [stateProcess, setStateProcess] = useState("init");
   const [fakeHtml, setFakeHtml] = useState();
   const [loading, setLoading] = useState(false);
   const [pdfannexes, setPdfAnnexes] = useState([]);
   const formService = new FormsService();
   const [isInit, setIsInit] = useState(false);
   const [data, setData] = useState({
      entity: props?.currentEntity?.name,
      insee_com: props.currentCom,
      label_com: props.currentComLabel,
      terr_addr: props.terrAddr||null,
      terr_seller_name: null,
      terr_acquir_name: null,
      terr_process: null,
      terr_code_base: props?.currentParcelle[0],
      terr_code_all: props?.currentParcelle.join(","),
      entity_id: props?.currentEntity?.id,
      dem_date: new Date().toLocaleDateString(),
      dem_name: props.demName || "ND", 
      dem_addr: "ND",
      dem_city: "ND",
      dem_cp: "ND",
      dem_phone: "ND",
      dem_email: props.demEmail||"ND",
      dem_raison_sociale: "ND",
      pdf_annexes: pdfannexes,
   });

   const {
      register,
      handleSubmit,
      reset,
      formState: { errors },
   } = useForm({ defaultValues: data });

   useEffect(() => {
      //console.log(props.forms);
      handleRunProcess(props), setStateProcess("final");
   }, []);

   const buildDocNumber = async (formType = null, index = 0) => {
      return new Promise((resolve) => {
         let formulaireType = formType ? formType.toUpperCase() : String(forms[0]?.metadata?.prod_lib).toUpperCase();
         resolve(
            formulaireType +
               "0" +
               props.currentCom +
               String(new Date().getFullYear()).substring(2) +
               ("00" + (Number(props?.lastDocNumber) + index + 1)).substring(-3)
         );
      });
   };

   const handleRemoveForm = (item) => {
      setForms(forms.filter((form) => form.id !== item.id));
   };

   const handleRunProcess = async () => {
      setLoading(true);
      let result = await axios.get("Api/user/entity/has_default_payment");
      if (result?.data?.sepa?.length && result?.data?.isSubscriber) {
         reset({ ...data, doc_code: await buildDocNumber() });
         //  setStateProcess("formProcess");
         outsideSubmit();
      } else {
         setStateProcess("paymentMethodError");
      }
      setLoading(false);
   };

   const recordScreenCapture = (index, result, result1) => {
      formService
         .captureScreenLocation(null, 72, 3, screenCaptsERP[index].layers)
         .then((res) => {
            screenCaptsERP[index].content = res;
            axios
               .post("/Api/Form_data/storeScreenCapture", {
                  capts: [screenCaptsERP[index]],
                  form_ref_id: result1.data.id,
               })
               .then((resultCapt) => {});
            if (index === screenCaptsERP.length - 1) {
               const refMap = $("#map").data("map");
               formService.prepareMap(refMap);
               recordResult(result, result1);
            } else {
               index++;
               recordScreenCapture(index, result, result1);
            }
         })
         .catch((err) => {
            console.log(err);
         });
   };
   const outsideSubmit = () => {
      handleSubmit(onSubmit)();
   };
   const onSubmit = async (e) => {
      e.dem_raison_sociale = e.dem_name;
      await boucleForms(e);
   };

   const boucleForms = async (formsData) => {
      setIsInit(true);
      setLoading(true);
      setProcessRun(0);
      props.resetForm();
      props.toggleLayerStack();
      forms.map(async (form, index) => {
         let formType = form?.metadata?.prod_lib;
         //console.log('type', form?.metadata?.prod_lib, formType);
         setSelectedForm(form?.metadata?.prod_lib);
         props.resetScreenCapt();
         let resultHtml = await renderHTMLData(form?.metadata?.prod_lib, form?.metadata?.prod_level, index);
         setProcessRun((index / forms.length) * 100);
         let newCode = await buildDocNumber(form?.metadata?.prod_lib, index);
         let level = form?.metadata?.prod_level ?? "basic";
         formsData = { ...formsData, code: newCode, doctype: formType.toUpperCase(), level: level };
         //console.log('form',formsData);
         let result2 = await axios.post("/Api/Form_ref", formsData);

         if (formType.toLowerCase() === "erp") {
            // cf vieille version !!!
         } else {
            const formparams = {
               form_ref_id: result2.data.id,
               data_values: props.dataValues,
               img_ref: formType.toLowerCase() === "nru" || formType === "ru" ? props.locationScreenCapt : "empty",
               form_links: props.formLinks,
               html_content: resultHtml,
               product_id: form.id,
            };
            let result3 = axios.post("/Api/Form_data/store", formparams);
            //console.log('result3', result3);
            if (index === forms.length - 1) {
               setStateProcess("final");
            }
         }
         setLoading(false);
         setProcessRun(false);
      });
   };

   const renderHTMLData = async (form, level, index) => {
      return new Promise((resolve, reject) => {
         setFakeHtml(
            <FormWrarper
               formSelect={form}
               level={level}
               screenCapt={props.locationScreenCapt}
               demInfo={props.demInfo}
               addressBien={props.addressBien}
            />
         );
         let htmlref = document.getElementById("form-dem-data").innerHTML;
         setFakeHtml(null);
         resolve(htmlref);
      });
   };

   const renderSetAddress = () => {
      //reset(data);
      return (
         <div className="d-flex flex-column justify-content-start align-self-start w-100">
            <div className="font-weight-bold my-3">Références d'enregistement</div>
            <form
               className=" w-100"
               method="post"
               id={"form_submit_" + props.currentEntity.id}
               onSubmit={handleSubmit(onSubmit)}
            >
               <div className="form-group col-12">
                  <label htmlFor="doc_code" className=" ue-col-form-label">
                     Numéro de dossier
                  </label>
                  <input
                     readOnly
                     type="text"
                     className="form-control ue-form-control"
                     id="doc_code"
                     name="doc_code"
                     {...register("doc_code", { required: "Ce champs est requis !" })}
                  />
                  {errors.dem_code && (
                     <p role="alert" className={"ue-form-error"}>
                        {errors.dem_code?.message}
                     </p>
                  )}
               </div>
               <div className="form-group col-12">
                  <label htmlFor="dem_date" className="ue-col-form-label">
                     Date de demande
                  </label>
                  <input
                     readOnly
                     type="text"
                     className="form-control ue-form-control"
                     id="dem_date"
                     name="dem_date"
                     {...register("dem_date", { required: "Ce champs est requis !" })}
                  />
                  {errors.dem_date && (
                     <p role="alert" className={"ue-form-error"}>
                        {errors.dem_date?.message}
                     </p>
                  )}
               </div>
               <div className="form-group col-12">
                  <label htmlFor="dem_name" className=" ue-col-form-label">
                     Nom du demandeur
                  </label>
                  <input
                     readOnly
                     type="text"
                     className="form-control ue-form-control"
                     id="dem_name"
                     name="dem_name"
                     {...register("dem_name", { required: "Ce champs est requis !" })}
                  />
                  {errors.dem_name && (
                     <p role="alert" className={"ue-form-error"}>
                        {errors.dem_name?.message}
                     </p>
                  )}
               </div>
               {/*<input type="text" id="address" name="address" class="form-control"  placeholder="Adresse">
                    <input type="text" id="cp" name="cp" class="form-control mt-3"  placeholder="Code Postale">
                    <input type="text" id="city" name="city" class="form-control mt-3"  placeholder="Commune">
                    <input type="text" id="terr_seller_name" name="terr_seller_name" class="form-control mt-3"  placeholder="Vendeur">
                    <input type="text" id="terr_acquir_name" name="terr_acquir_name" class="form-control mt-3"  placeholder="Acquéreur">
                    <input type="text" id="terr_process" name="terr_process" class="form-control mt-3"  placeholder="Procédure">
                    */}
               {/* <div className={"w-100 text-center mt-2"}>
                  <button id="submit_form_btn" onClick={outsideSubmit} className="btn btn-primary btn-lg text-white">
                     {loading ? <UELoaderAnim /> : "SUIVANT"}
                  </button>
               </div> */}
            </form>
         </div>
      );
   };

   return (
      <>
         {processRun ? <ProgressBar bgcolor={"#93e3d9"} completed={processRun} /> : null}

         {stateProcess === "init" ? (
            <div className={"d-flex flex-column w-100 justify-content-start text-center align-items-center"}>
               <h4 className={"mb-1 text-center text-gray-400"}>Étes vous sûr de vouloir acqérir ces éléments ?</h4>
               <div className={"flex flex-column w-100 my-2"}>
                  {forms?.length
                     ? forms.map((item, index) => {
                          return (
                             <div
                                className={"d-flex justify-content-between align-items-center my-2 w-100"}
                                key={index}
                             >
                                <div className={"text-left"}>
                                   {item.metadata?.prod_level === "demo" ? (
                                      <div className={"ue-form-tag-demo d-inline-block"}>DEMO</div>
                                   ) : null}
                                   {item.metadata?.prod_level === "pro" ? (
                                      <div className={"ue-form-tag-pro d-inline-block"}>PRO</div>
                                   ) : null}
                                   {item.metadata?.prod_level === "basic" ? (
                                      <div className={"ue-form-tag-basic d-inline-block"}>BASIC</div>
                                   ) : null}
                                   <div className={"mx-2 d-inline-block"}>{item.name}</div>
                                </div>
                                {props.currentEntity?.genre?.slug !== "collective" ? (
                                   <div className={"font-weight-bold text-primary"}>
                                      {new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
                                         item.price.unit_amount / 100
                                      )}
                                   </div>
                                ) : null}
                                <div
                                   className={"btn btn-outline-light text-gray-300"}
                                   onClick={() => handleRemoveForm(item)}
                                >
                                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                      <g fill="#888888">
                                         <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                         <path
                                            fillRule="evenodd"
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                         />
                                      </g>
                                   </svg>
                                </div>
                             </div>
                          );
                       })
                     : null}
                  <BlocPayLogo />
               </div>
               <div className={"d-flex w-100 justify-content-center my-3"}>
                  <button className={"btn btn-outline-primary btn-lg btn-block mr-3"} onClick={props.onClose}>
                     Annuler
                  </button>
                  <button
                     className={"btn btn-primary text-white btn-lg btn-block mt-0"}
                     onClick={(e) => handleRunProcess()}
                  >
                     {loading ? <UELoaderAnim /> : "Oui"}
                  </button>
               </div>
            </div>
         ) : null}

         {/* {stateProcess === "formProcess" ? loading ? <UELoader /> : renderSetAddress() : null} */}

         {stateProcess === "final" ? (
            <div className={"d-flex flex-column justify-content-start text-center align-items-center"}>
               <h2>Succès !</h2>
               <h4 className={"mb-2 text-center text-gray-400"}>Votre formulaire a été créé dans vos dossiers</h4>
               <br />
               <div className={"d-flex w-100 justify-content-center"}>
                  <button
                     className={"btn btn-outline-primary btn-lg text-black"}
                     onClick={() => {
                        props.showCurrentSection("dashboard");
                        props.showCenterSection("center_zone");
                        props.setCurrentCenterPage("dashboard");
                     }}
                  >
                     Dossiers
                  </button>
               </div>
               <br />
               <div className={"d-flex w-100 justify-content-center"}>
                  <button className={"btn btn-primary btn-lg text-white"} onClick={props.onClose}>
                     Fermer
                  </button>
               </div>
            </div>
         ) : null}
         {stateProcess === "paymentMethodError" ? (
            <div className={"text-center"}>
               <svg className={"my-3"} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                  <path
                     fill="#888888"
                     d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
                  />
               </svg>
               <h4 className={"mb-5 text-center text-gray-400"}>Impossible de poursuivre ce processus ! </h4>
               <h5>Un problème s'est produit lors de la validation des éléments de votre structure.</h5>
               <h5>
                  Votre structure ne possède peut être pas actuellement
                  <br /> d'abonnement ou de moyen de paiement valide enregistré ?
               </h5>
               <h5
                  className={"btn btn-outline-primary rounded my-2"}
                  onClick={() => {
                     props.showCurrentSection("contact");
                     props.showCenterSection("center_zone");
                     props.setCurrentCenterPage("contact");
                  }}
               >
                  Contacter l'assistance
               </h5>
            </div>
         ) : null}
         {stateProcess === "noAccess" ? (
            <div className={"text-center"}>
               <svg className={"my-3"} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                  <path
                     fill="#888888"
                     d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
                  />
               </svg>
               <h4 className={"mb-5 text-center text-gray-400"}>Impossible de poursuivre ce processus ! </h4>
               <h5>Il semblerai que vous n'ayez pas les droits suffusant pour accéder à cette ressource</h5>
               <h5>Si vous pensez qu'il s'agit d'une erreur vous pouvez </h5>
               <h5
                  className={"btn btn-outline-primary rounded my-2"}
                  onClick={() => {
                     props.showCurrentSection("contact");
                     props.showCenterSection("center_zone");
                     props.setCurrentCenterPage("contact");
                  }}
               >
                  Contacter l'assistance
               </h5>
            </div>
         ) : null}
         {stateProcess === "error" ? (
            <div>
               <h3>Erreur !</h3>
            </div>
         ) : null}
         {fakeHtml ? fakeHtml : null}
      </>
   );
};

const mapStateToProps = (state) => {
   return {
      uiTheme: state.AppReducer.ui_theme,
      currentCom: state.MapReducer.currentCom,
      currentComLabel: state.MapReducer.currentComLabel,
      currentParcelle: state.MapReducer.currentParcelle,
      currentEntity: state.MeReducer.entity,
      userSubscription: state.MeReducer.subscription,
      dataValues: state.FormsReducer.formData,
      addressBien: state.FormsReducer.addressBien,
      lastDocNumber: state.MeReducer.lastDocNumber,
      meName: state.MeReducer.name,
      meEmail: state.MeReducer.email,
      demInfo: state.FormsReducer.demandeur,
      locationScreenCapt: state.MapReducer.locationScreenCapt,
      formLinks: state.FormsReducer.formLinks,
      countTotalDataRef: state.FormsReducer.countTotalDataRef,
      listDataRef: state.FormsReducer.listDataRef,
      dataFormIsReady: state.FormsReducer.dataFormIsReady,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      toggleLayerStack: () => dispatch({ type: "TOGGLE_LAYERS_STACK" }),
      showTabPanel: (e) => dispatch({ type: "TOGGLE_PANEL_TAB", data: { currentTab: e } }),
      initForm: (e) => dispatch({ type: "INIT_FORM", data: { formRef: e } }),
      resetForm: (e) => dispatch({ type: "RESET_FORM" }),
      resetScreenCapt: () => dispatch({ type: "RESET_SCREEN_CAPT" }),
      saveFomData: (e) => dispatch({ type: "SAVE_FORM_DATA", data: { form_ref_id: e } }),
      updateDemandeurInfo: (e) => dispatch({ type: "UPDATE_DEMANDEUR_INFO", data: { demInfo: e } }),
      saveAdressBien: (e) => dispatch({ type: "SAVE_ADDRESS_BIEN", data: e }),
      showCurrentSection: (e) => dispatch({ type: "SHOW_CURRENT_SECTION", data: e }),
      setLeftPanelOpen: (e) => dispatch({ type: "SET_LEFT_PANEL_OPEN", data: e }),
      setCurrentCenterPage: (e) => dispatch({ type: "SET_CURRENT_PAGE", data: e }),
      showCenterSection: (e) => dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(StoreFormProcess);
